import {
  IconButton,
  LoadingDots,
  LoadingSpinner,
  Modal,
} from 'components/core';
import Image from "next/legacy/image";
import { MdClose } from 'react-icons/md';
import { FC, useEffect, useState } from 'react';
import { useCreateExportProjectJob } from 'reactQuery/mutations';
import { useDoctorProfile } from 'reactQuery/queries';
import { LineItemPreviewModalProps, Styled } from './';

const LineItemPreviewModal: FC<LineItemPreviewModalProps> = ({
  projectId,
  onClose,
}) => {
  const [previewUrl, setPreviewUrl] = useState();
  const downloadCustomizedAssetMutation = useCreateExportProjectJob(false);
  const { data: doctorProfile } = useDoctorProfile();
  useEffect(() => {
    const createPreviewUrl = async () => {
      const data = await downloadCustomizedAssetMutation.mutateAsync({
        clinid: doctorProfile?.userName,
        projectId: projectId,
        format: 'jpg',
      });
      setPreviewUrl(data?.thumbnailUrl);
    };
    createPreviewUrl();
  }, []);
  return (
    <Modal>
      <Styled.ModalContainer>
        <Styled.ModalHeader>
          <div>
            {' '}
            {downloadCustomizedAssetMutation.isLoading && 'Loading Preview...'}
          </div>
          <IconButton onClick={onClose} showBorder={true} size="xs">
            <MdClose />
          </IconButton>
        </Styled.ModalHeader>

        <Styled.ModalBody>
          {!downloadCustomizedAssetMutation.isLoading && previewUrl && (
            <img
              src={previewUrl}
              width="80%"
              style={{ pointerEvents: 'none' }}
            />
          )}

          {downloadCustomizedAssetMutation.isLoading && (
            <Styled.PreviewLoadingContainer>
              <LoadingSpinner />
            </Styled.PreviewLoadingContainer>
          )}
        </Styled.ModalBody>
        <Styled.ModalFooter></Styled.ModalFooter>
      </Styled.ModalContainer>
    </Modal>
  );
};

export default LineItemPreviewModal;
